import { render, staticRenderFns } from "./NotificationPanelItem.vue?vue&type=template&id=6dfa45aa"
import script from "./NotificationPanelItem.vue?vue&type=script&lang=js"
export * from "./NotificationPanelItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports